import React, { createContext, useContext, useState } from 'react';

const RecordingContext = createContext({
  isRecording: false,
  setIsRecording: () => {},
});

export function RecordingProvider({ children }) {
  const [isRecording, setIsRecording] = useState(false);

  return (
    <RecordingContext.Provider value={{ isRecording, setIsRecording }}>
      {children}
    </RecordingContext.Provider>
  );
}

export function useRecordingContext() {
  return useContext(RecordingContext);
}
